
class QuickView {
    constructor() {
        let doc = document
        this.qsa = (s, o = doc) => o.querySelectorAll(s),
            this.qs = (s, o = doc) => o.querySelector(s)

        this.$body = document.querySelector('body')
        this.$fader = document.querySelector('.screen-fader')

        this.quickview = {
            $el: this.qs('.quickview'),
            $close: this.qs('.quickview__close'),
            $trg: this.qsa('.qv-trg'),
            $content: this.qs('.quickview__content'),
            $more_details: this.qs('.quickview__moredetails'),
            $more_details_link: this.qs('.quickview__moredetails a'),
        }

        this.link = null
        this.$new_header = null
        this.onClick()
        this.controlQuickView()
    }


    onClick() {
        this.quickview.$trg.forEach((el, index) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                
                this.quickview.$el.classList.add('loading', 'go-spin')
                this.link = el.getAttribute('href')
                this.onFetch()
            })
        })
    }
    











    //? - =========================  FETCH  ========================= -//
    //? - =========================  FETCH  ========================= -//
    onFetch() {
        let that = this
        fetch(this.link).then(function (response) {
            return response.text();
        })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                
                that.contentReady(doc)
                let removeLoading = setTimeout(function ()  {
                    that.quickview.$el.classList.remove('loading')
                    clearTimeout(removeLoading);
                }, 2000);
                let removeSpin = setTimeout(function ()  {
                    that.quickview.$el.classList.remove('go-spin')
                    clearTimeout(removeSpin);
                }, 2600);
            })
            .catch(function (err) {
                console.warn('Something went wrong.', err);
            });
    }


    contentReady($newPage) {
        let newHeader = {
            $el: $newPage.querySelector('.header-product'),
            $infos: $newPage.querySelector('.header-prod__infos__hold'),
        }
        this.quickview.$content.innerHTML = newHeader.$el.outerHTML
        this.$new_header =  document.querySelector('.quickview .header-product')
        this.quickview.$more_details_link.setAttribute('href', this.link)
        let clone = this.quickview.$more_details.cloneNode(true);
        document.querySelector('.quickview .header-prod__infos__hold').appendChild(clone);

    }



    
    
    
    
    
    
    
    
    
    
    //? - =========================  control quickview  ========================= -//
    //? - =========================  control quickview  ========================= -//
    controlQuickView() {
        let that = this
        function openquickview() {
            that.$body.classList.add('is-quickview')
        }
        function closequickview() {
            that.$body.classList.remove('is-quickview')
            let removeOld = setTimeout(function ()  {
                    that.$new_header.remove() 
                    clearTimeout(removeOld);
                }, 1000);
        }

        this.quickview.$trg.forEach((el, index) => {
            el.addEventListener('click', ()=> {
                if(that.$body.classList.contains('is-quickview')) { closequickview() }
                else { openquickview() }
            })
        })

        this.quickview.$close.addEventListener('click', ()=> {
            closequickview() 
        })
        

        this.$fader.addEventListener('click', ()=> {
            that.$body.classList.contains('is-quickview') ? closequickview() : null
            
        })
    }
}
new QuickView()